interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`max-w-2xl ${isCenter ? "mx-auto text-center" : ""}`}>
      {eyebrow ? (
        <div
          className={`mb-3 inline-flex items-center gap-2 ${
            isCenter ? "justify-center" : ""
          }`}
        >
          <span className="h-[6px] w-[6px] rounded-full bg-accent-500"></span>
          <span className="font-label text-xs tracking-[0.2em] text-secondary-700 uppercase">
            {eyebrow}
          </span>
        </div>
      ) : null}
      <h2 className="text-2xl md:text-4xl font-bold leading-snug text-foreground-950">
        {title}
      </h2>
      {desc ? (
        <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
          {desc}
        </p>
      ) : null}
    </div>
  );
}